import {
  CREATE_USER_ADDRESS,
  GET_MEMBERSHIP_CARDS_WITH_POINTS,
  GET_STORE_AREAS,
  GET_USER_ADDRESSES,
  GET_USER_DETAILS,
  UPDATE_USER_ADDRESS
} from 'services/user/queries';
import {
  AddressTypeEnum,
  CreateAddressInputType,
  UserDetail,
  StoreArea,
  UpdateAddressInputType,
  UserAddress
} from 'types';
import {MembershipCard} from 'types/membership';
import {userGraphqlRequest} from 'utils/graphqlRequests';

export async function createUserAddressV1(createAddressInput: CreateAddressInputType): Promise<UserAddress> {
  const result = await userGraphqlRequest(CREATE_USER_ADDRESS, {createAddressInput});
  return result.createUserAddress as UserAddress;
}

export async function updateUserAddressV1(
  addressId: string,
  updateAddressInput: UpdateAddressInputType,
  addressType?: AddressTypeEnum
): Promise<UserAddress> {
  // To do: input values should not be created in this function this should be in sagas
  const {id: _, ...addressInput} = updateAddressInput;
  const result = await userGraphqlRequest(UPDATE_USER_ADDRESS, {
    addressId,
    updateAddressInput: addressInput,
    addressType
  });
  return result.updateUserAddress;
}

export async function getStoreAreasV1(
  filter?: Partial<StoreArea>,
  suggestion?: Partial<StoreArea>,
  pageNo?: number,
  pageLength?: number
): Promise<StoreArea[]> {
  const result = await userGraphqlRequest(GET_STORE_AREAS, {
    filter,
    suggestion,
    pageNo,
    pageLength
  });
  return result.getStoreAreas;
}

export async function getMakroMembershipCardsV2(idToken: string): Promise<MembershipCard[]> {
  const result = await userGraphqlRequest(GET_MEMBERSHIP_CARDS_WITH_POINTS, {
    accessToken: idToken // why??? why not just take this from the auth?
  });
  return result.getMakroMembershipCards;
}

export async function getUserAddressesV1(addressType?: AddressTypeEnum): Promise<UserAddress[]> {
  const result = await userGraphqlRequest(GET_USER_ADDRESSES, {addressType});
  return result.getUserAddresses as UserAddress[];
}

export async function getUserDetails(): Promise<UserDetail> {
  const result = await userGraphqlRequest(GET_USER_DETAILS, {});
  return result.getUserDetails as UserDetail;
}
